import React, {useEffect, useState} from "react";
import {CallCenter, MessageRed, WhatsAppIcon} from "../assets/icons";
import {useSettings} from "../hooks/SettingsContext";


const ContactUsInfo = () => {
	const settings = useSettings();
	const [socialLinks, setSocialLinks] = useState([
		{ icon: <WhatsAppIcon className="w-[100px] h-[100px]" />, href: "#" },
		{ icon: <MessageRed className="w-[100px] h-[100px]" />, href: "#" },
		{ icon: <CallCenter className="w-[100px] h-[100px]" />, href: "#" },
	]);

	useEffect(() => {
		setSocialLinks((prevLinks) =>
			prevLinks.map((link, index) => {
				switch (index) {
					case 0: // WhatsApp
						return settings?.whatsapp
							? { ...link, href: "https://wa.me/" + settings.whatsapp }
							: link;
					case 1: // Email
						return settings?.icon_email
							? { ...link, href: "mailto:" + settings.icon_email }
							: link;
					case 2: // Phone
						return settings?.phone
							? { ...link, href: "tel:" + settings.phone }
							: link;
					default:
						return link;
				}
			})
		);
	}, [settings]);

	return (
		<div className="fixed right-0 md:right-4 md:bottom-10 bottom-8 z-[999]">
			<div
				className={`flex flex-col items-center justify-center gap-1.5 md:gap-3`}
			>
				{socialLinks.map((link, index) => (
					link.href !== '#' && 	<a
						className="w-[40px] h-[40px] md:w-[60px] md:h-[60px] flex items-center justify-center rounded-full hover:bg-primary-700 transition-colors delay-150"
						key={index}
						href={link.href}
						target="_blank"
						rel="noopener noreferrer"
					>
						{link.icon}
					</a>

				))}
			</div>
		</div>
	);
};

export default ContactUsInfo;
